import { useAuthenticated } from "nate-react-api-helpers";
import { useLocation } from "react-router-dom";
import { Redirect } from "./Redirect";

export function LoginRedirector(props: { ignore: string[] }) {
    const auth = useAuthenticated();
    const loc = useLocation();

    if (auth.authenticated) return null;
    if (props.ignore.includes(loc.pathname)) return null;

    // remember where the user was headed so LoginPage can send them back
    const params = new URLSearchParams();
    params.set("r", loc.pathname + loc.search);

    return <Redirect to={"/login?" + params.toString()} />;
}
